export type { SaleChange } from '@src/domains/sale-changes/types/saleChange';
export { SaleChangeStatusEnum, SaleChangeTypeEnum } from '@src/domains/sale-changes/types/saleChange';

export { extractRescheduleSaleChanges } from '@src/domains/sale-changes/core/extractRescheduleSaleChanges';
export { getLastRescheduleSaleChange } from '@src/domains/sale-changes/core/getLastRescheduleSaleChange';
export { resolveSaleChangeAmounts } from '@src/domains/sale-changes/core/resolveSaleChangeAmounts';
export { resolveSaleChangeFeedback } from '@src/domains/sale-changes/core/resolveSaleChangeFeedback';
export type { SaleChangeFeedback } from '@src/domains/sale-changes/core/resolveSaleChangeFeedback';
export { resolveSaleChangeCheckoutOutcome } from '@src/domains/sale-changes/core/resolveSaleChangeCheckoutOutcome';
export { SaleChangeCheckoutOutcome } from '@src/domains/sale-changes/core/resolveSaleChangeCheckoutOutcome';
export { shouldShowSaleChangeStatus } from '@src/domains/sale-changes/core/shouldShowSaleChangeStatus';
export {
  getSaleChangeTotalAmountCents,
  getSaleChangeComparisonAmounts,
  saleChangeSummaryHasComparison,
} from '@src/domains/sale-changes/core/saleChangeSummary';
